import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { MaterialTabs, SectionSubHeader } from 'components/layout'
import { ActivityProgress } from 'components/misc'
import { ACTIVITY_SECTIONS } from 'constants/enums'
import styles from './aj-sub-header.styl'

const tabs = [
  {
    id: 0,
    label: 'Report',
    intlKey: 'tabs.report',
    to: 'report'
  },
  {
    id: 1,
    label: 'Overview',
    intlKey: 'tabs.overview',
    to: 'overview'
  },
  {
    id: 2,
    label: 'Files',
    intlKey: 'tabs.files',
    to: 'files'
  }
]

export default class AJSubHeader extends Component {
  static propTypes = {
    aJProgress: PropTypes.array,
    title: PropTypes.object,
    activityRoute: PropTypes.string,
    subtitle: PropTypes.object,
    isPrepAndTrain: PropTypes.bool
  }

  render() {
    const {
      title,
      subtitle,
      aJProgress,
      activityRoute,
      isPrepAndTrain
    } = this.props

    const aJSection = ACTIVITY_SECTIONS.adventurous_journey.id

    let tabsProp = null

    if (isPrepAndTrain) {
      tabsProp = [...tabs]
      tabsProp[0] = {
        id: 0,
        label: 'Activity',
        intlKey: 'tabs.activity',
        to: 'activity'
      }
    }
    return (
      <SectionSubHeader
        title={title}
        subtitle={subtitle}
        activitySection={aJSection}
        progress={
          <div className={styles.progressWrap}>
            {aJProgress.map((item, index) => (
              <div className={styles.progressItem} key={index}>
                <ActivityProgress
                  activitySection={aJSection}
                  completedPercentage={item ? 100 : 0}
                  white
                />
              </div>
            ))}
          </div>
        }
        tabs={<MaterialTabs root={activityRoute} items={tabsProp || tabs} />}
      />
    )
  }
}
